import { put, call } from 'redux-saga/effects';
import { Types } from './actions';
import { Types as TypesCancel } from '../UpdatePhoto/cancelUseCase/actions';
import { Types as TypesActivatePayment } from '../certificateType01/activatePaymentUseCase/actions';
import { Types as TypesRegisterCertificate } from '../certificateType01/registerUseCase/actions';
import { Types as TypesRetreatCourse } from '../retreatCourses/registerWithdrawalCourses/actions';
import { Types as TypesActivateRetreatCourse } from '../retreatCourses/activateWithdrawalCourse/actions';
import { Types as TypesRegister } from '../pse/registerInsuranceValidation/actions';
import ProceduresRepository from '../../../repositories/ProceduresRepository';
import ProceduresDataRepository from '../../../../data/repositories/ProceduresDataRepository';

export default function* execute(): any {
  try {
    yield put({ type: Types.GET_PROCEDURES_BY_STUDENT_REQUEST });
    const procedureRepository: ProceduresRepository =
      new ProceduresDataRepository();
    const procedureResponse = yield call(
      procedureRepository.getProceduresByStudent
    );
    if (!procedureResponse) {
      yield put({
        type: Types.GET_PROCEDURES_BY_STUDENT_FAILURE,
        error: 'No se pudo leer los datos del trámite.'
      });
      return;
    }
    yield put({
      type: TypesRegisterCertificate.REGISTER_CERTIFICATE_OF_STUDIES_CLEAR
    });
    yield put({
      type: TypesCancel.CANCEL_UPDATE_PHOTO_CLEAR,
      data: procedureResponse
    });
    yield put({
      type: TypesActivatePayment.ACTIVATE_CERTIFICATE_OF_STUDIES_CLEAR
    });
    yield put({
      type: Types.GET_PROCEDURES_BY_STUDENT_SUCCESS,
      data: procedureResponse
    });
    yield put({
      type: 'ACTIVATE_PAY_ORDER_CLEAR'
    });
    yield put({
      type: 'GET_STUDENT_PROCEDURE_STATUS_CLEAR'
    });
    yield put({
      type: 'PROCESS_FORM_BSE_CLEAR'
    });
    yield put({
      type: 'REGISTER_REINCORPORATION_CLEAR'
    });
    yield put({
      type: 'ACTIVATE_PAYMENT_CLEAR'
    });
    yield put({
      type: 'REGISTER_LATE_COURSES_CLEAR'
    });
    yield put({
      type: 'ACTIVATE_PAYMENT_COURSES_CLEAR'
    });
    yield put({
      type: 'REGISTER_CHANGE_PHOTO_CLEAR'
    });
    yield put({
      type: 'REGISTER_RETIREMENT_OF_PERIOD_CLEAR'
    });
    yield put({
      type: 'CANCEL_RETIREMENT_OF_PERIOD_CLEAR'
    });
    yield put({
      type: 'CANCEL_CHANGE_PROGRAM_CAMPUS_MODALITY_CLEAR'
    });
    yield put({
      type: TypesRetreatCourse.REGISTER_WITHDRAWAL_COURSES_CLEAR
    });
    yield put({
      type: TypesActivateRetreatCourse.ACTIVATE_WITHDRAWAL_COURSES_CLEAR
    });
    yield put({
      type: TypesRegister.REGISTER_PSE_CLEAR
    });
    yield put({ type: 'GET_PROCEDURE_INFORMATION_CLEAR' });
  } catch (error) {
    yield put({
      type: Types.GET_PROCEDURES_BY_STUDENT_FAILURE,
      error:
        'Ocurrió un error al momento de leer los datos del trámite solicitado.'
    });
  }
}
